import {
  Juzgado,
  ParamsPromociones,
} from "interfaces/promociones/promocionesInterface";
import {
  BodyTipoCarpetasPenales,
  DataTiposCarpetas,
} from "interfaces/serviciosGenerales/serviciosGeneralesInterface";
import { obtenerTipoCarpetasPenales } from "services/expedientesAutorizados/expedientesAutorizadosServices";
import { getJuzgadosOrdinariasEnLinea } from "services/promociones/promocionesService";
import {
  onAddLstJuzgados,
  onAddLstTipoCarpetas,
  onChangeAministiaType,
  onResetAmnistia,
} from "store/amnistia/amnistiaSlice";
import { useAppDispatch, useAppSelector } from "./reduxHooks";

export const useAmnistiaStore = () => {
  const { typePenal, lstJuzgados, lstTipoCarpetas } = useAppSelector(
    (state) => state.amnistia
  );

  const dispatch = useAppDispatch();

  const startGetJuiciosOrdinariasEnLinea = (params: ParamsPromociones) => {
    dispatch(onAddLstJuzgados([]));
    getJuzgadosOrdinariasEnLinea(params)
      .then(({ data }) => {
        const dataListJuzgados = data.data.map((juzgado: Juzgado) => {
          let body = {
            label: juzgado.DesJuz,
            value: juzgado.IdJuzgado,
            ...juzgado,
          };
          return body;
        });
        dispatch(onAddLstJuzgados(dataListJuzgados));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetTipoNumeros = (params: BodyTipoCarpetasPenales) => {
    dispatch(onAddLstTipoCarpetas([]));
    obtenerTipoCarpetasPenales(params)
      .then(({ data }) => {
        const dataListTipoCarpetas = data.data.map(
          (tipoCarpeta: DataTiposCarpetas) => {
            let body = {
              label: tipoCarpeta.descTipoNumero,
              value: tipoCarpeta.cveTipoNumero,
              ...tipoCarpeta,
            };
            return body;
          }
        ).filter((tipoCarpeta: DataTiposCarpetas) => {
          // filtrar que no se muestren los tipos de carpetas 7, 8 y 1
          return Number(tipoCarpeta.value) !== 7 && Number(tipoCarpeta.value) !== 8 && Number(tipoCarpeta.value) !== 1;
        });
        dispatch(onAddLstTipoCarpetas(dataListTipoCarpetas));
      })
      .catch((err) => {
        if (err.response.status === 404) {
          let body = {
            label: err.response.data.data,
            value: 0,
          };
          dispatch(onAddLstTipoCarpetas([body]));
        }
      });
  };

  const changeTypePenal = (status: boolean) =>
    dispatch(onChangeAministiaType(status));
    const resetAmnistia = () => dispatch(onResetAmnistia())

  return {
    /**methods */
    typePenal,
    lstJuzgados,
    lstTipoCarpetas,
    /**properties */
    changeTypePenal,
    startGetJuiciosOrdinariasEnLinea,
    startGetTipoNumeros,
    resetAmnistia
  };
};
